// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import MessageForm from 'src/components/message_form/message_form'

// helpers
import { textResources } from 'src/lang/de'

const labels = textResources.feedback

interface IFeedbackProps {
  close: () => void;
  loggedInUserEmail?: string;
}

export const ThanksBody: React.FC = () => (
  <p>{labels.thanksMessage}</p>
)

const Feedback: React.FC<IFeedbackProps> = ({
  close,
  loggedInUserEmail
}) => {
  return (
    <MessageForm
      successImage='feedback-success'
      successTitle={labels.thanksTitle}
      successBody={<ThanksBody />}
      body={labels.message}
      close={close}
      loggedInUserEmail={loggedInUserEmail}
      title={labels.title}
    />
  )
}

export default Feedback
